import { useFormikContext } from 'formik'
import { useCallback } from 'react'

type Props = {
  name: string
  onChange?: (v: any) => void
  noTouchValidation?: boolean
}

export function useHandlers(props: Props) {
  const { name, onChange, noTouchValidation } = props
  const { setFieldValue, setFieldTouched } = useFormikContext<{
    assigneeId: any
    ownerId: any
  }>()

  const handleChange = useCallback(
    (_: any, value) => {
      if (!noTouchValidation) {
        setFieldTouched(name)
      }
      setFieldValue(name, value?.id ? value?.id : '')

      if (onChange) {
        onChange(value)
      }
    },
    [name, noTouchValidation, onChange, setFieldTouched, setFieldValue],
  )

  const handleOnBlur = useCallback(() => {
    setFieldTouched(name)
  }, [name, setFieldTouched])

  return {
    handleChange,
    handleOnBlur,
  }
}
